import {findAllIn} from '@elements/dom-utils';
import {onFind} from "@elements/init-modules-in-scope";

const defaultSelectors = {
    filter: '.js-filter-category',
    category: '.js-filter-services-category',
    reset: '.js-filter-category-reset',
};

export function init(selectors = defaultSelectors) {
    let filterCategories = [];
    let serviceCategories = [];
    let categoriesFiltered = [];

    onFind(selectors.category, function (serviceCategory) {
        serviceCategories.push(serviceCategory);
    })

    onFind(selectors.filter, function (filterCategory) {
        filterCategories.push(filterCategory);

        filterCategory.addEventListener("change", function (event) {

            if (event.currentTarget.checked) {
                categoriesFiltered.push(event.currentTarget);
                updateCategories();

            } else {
                categoriesFiltered.splice(categoriesFiltered.indexOf(event.currentTarget), 1);
                updateCategories();
            }
        })
    });

    onFind(selectors.reset, function (reset) {
        reset.addEventListener("click", function () {
            resetCategories();
        })
    })

    function updateCategories() {

        if (categoriesFiltered.length === 0) {
            resetCategories();
        } else {

            for (let i = 0; i < serviceCategories.length; i++) {
                let showCategory = false;

                for (let j = 0; j < categoriesFiltered.length; j++) {
                    if (serviceCategories[i].id === categoriesFiltered[j].id) {
                        showCategory = true;
                    }
                }

                if (!showCategory) {
                    serviceCategories[i].classList.add('removed');

                } else {
                    serviceCategories[i].classList.remove('removed');
               }
            }
        }
    }

    function resetCategories() {
        for (let i = 0; i < serviceCategories.length; i++) {
            //serviceCategories[i].classList.remove('d-none');
            serviceCategories[i].classList.remove('removed');
            filterCategories[i].checked = false;
            categoriesFiltered = [];

        }
    }
}